
export const SECOES = {
    SOLICITANTE: 'solicitante',
    DADOS_DO_PACIENTE: 'dadosDoPaciente',
    INDICACAO_CLINICA: 'indicacaoClinica',
    MEDICAMENTO: 'medicamentos',
};

/** Chaves exclusivas usadas como `key` em elementos React */
export const REACT_KEYS = {
    BTN_ENVIAR_EXAME: 'btn-enviar-exame',
    SEC_PACIENTE: 'sec-paciente',
    SEC_SOLICITANTE: 'sec-solicitante',
    SEC_INDICACAO: 'sec-indicacao',
    SEC_MEDICAMENTOS: 'sec-medicamentos',
};
